import type { BodyRequest } from '@pba/react-utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

// eslint-disable-next-line @typescript-eslint/naming-convention -- Keys are defined by Backend API endpoint
type TrackRecentSearchRequestBody = { recent_search: { id: string; type: string } };

export const trackRecentSearch = async ({ body }: BodyRequest<TrackRecentSearchRequestBody>) =>
  apiClient.post<unknown, ApiClientResponse<unknown>>(routes.recentSearches.create, {
    body,
  });
